/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import axios from 'axios';
import swal from 'sweetalert2';
import Loading from '../../components/common/Loading';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const MobileMenuBtn = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: #1c1c1e;
    border-radius: 10px;
    color: #f5f5f7;
    cursor: pointer;
    flex-shrink: 0;
  }
`;

const Container = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 94vh;
  overflow-y: auto;
  width: 100%;
  margin: 16px 16px 16px 0;
  padding: 28px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 4px 20px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    height: 100vh;
    margin: 0;
    border-radius: 0;
    padding: 16px;
  }
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0 0 20px 0;
`;

const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  color: #86868b;
  font-size: 15px;
`;

const ItemRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.1s;
  &:hover {
    background: rgba(0, 122, 255, 0.04);
  }
`;

const TypeBadge = styled.span`
  display: inline-flex;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  margin-right: 12px;
  background: ${({ $type }) =>
    $type === 'order' ? '#eef2ff' :
    $type === 'product' ? '#ecfdf5' : '#fef3c7'};
  color: ${({ $type }) =>
    $type === 'order' ? '#4338ca' :
    $type === 'product' ? '#065f46' : '#92400e'};
`;

const typeLabel = { order: '주문', product: '상품', user: '회원' };

const ItemInfo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const ItemText = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
`;

const ItemDetail = styled.span`
  font-size: 13px;
  color: #86868b;
  margin-left: 12px;
`;

const DeletedDate = styled.div`
  font-size: 13px;
  color: #86868b;
  margin-right: 16px;
  white-space: nowrap;
`;

const RestoreBtn = styled.button`
  padding: 6px 16px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: #007aff;
  color: white;
  transition: all 0.15s;
  &:hover {
    background: #0066d6;
  }
`;

const formatDate = (str) => {
  if (!str) return '-';
  const m = str.match(/(\d{4})\.(\d{2})\.(\d{2})-?(\d{2}):(\d{2})/);
  if (m) return `${m[1].slice(2)}/${m[2]}/${m[3]} ${m[4]}:${m[5]}`;
  return str;
};

const TrashPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTrash = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get('/admin/trash/list');
      setItems(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrash();
  }, []);

  const handleRestore = async (item) => {
    const result = await swal.fire({
      text: `"${item.label}"을(를) 복원하시겠습니까?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#007aff',
      cancelButtonColor: '#a3a3a3',
      confirmButtonText: '복원',
      cancelButtonText: '취소',
    });
    if (result.isConfirmed) {
      try {
        await axios.patch(`/admin/trash/restore/${item.type}/${item._id}`);
        swal.fire({ text: '복원되었습니다.', icon: 'success', showConfirmButton: false, timer: 1000 });
        fetchTrash();
      } catch {
        swal.fire({ text: '오류가 발생했습니다.', icon: 'error', showConfirmButton: false, timer: 1000 });
      }
    }
  };

  return (
    <Container>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
        <MobileMenuBtn onClick={() => window.dispatchEvent(new Event('open-sidebar'))}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </MobileMenuBtn>
        <Title style={{ margin: 0 }}>휴지통</Title>
      </div>
      {loading ? (
        <Loading />
      ) : items.length === 0 ? (
        <EmptyState>휴지통이 비어 있습니다.</EmptyState>
      ) : (
        items.map((item) => (
          <ItemRow key={`${item.type}_${item._id}`}>
            <ItemInfo>
              <TypeBadge $type={item.type}>{typeLabel[item.type]}</TypeBadge>
              <ItemText>{item.label}</ItemText>
              <ItemDetail>{item.detail}</ItemDetail>
            </ItemInfo>
            <DeletedDate>{formatDate(item.deletedAt)}</DeletedDate>
            <RestoreBtn onClick={() => handleRestore(item)}>복원</RestoreBtn>
          </ItemRow>
        ))
      )}
    </Container>
  );
};

export default TrashPage;
